module.exports = __webpack_public_path__ + "img/carloslleon.e8842fec.png";